import { forwardRef, useEffect, useState, useRef, useImperativeHandle } from 'react'

//* Component
import Icon from 'components/common/Icon'

//* Style
import VideoStyle from './style'

const CustomVideo = forwardRef((props, ref) => {
	//! Ref
	const videoRef = useRef()

	//! State
	const [isPlaying, setIsPlaying] = useState(props.autoplay)

	useImperativeHandle(ref, () => videoRef.current, [])

	useEffect(() => {
		if (isPlaying) {
			videoRef?.current?.play()
		} else {
			videoRef?.current?.pause()
		}
	}, [isPlaying])

	return (
		<VideoStyle
			onClick={() => {
				if (props.handleClick) {
					setIsPlaying(!isPlaying)
					props.handleClick()
				}
			}}
			className={`video-cont ${props.className || ''} ${props.autoplay ? 'not-hover' : ''}`}
		>
			<video
				playsInline
				ref={videoRef}
				loop={props.loop}
				preload={`metadata`}
				muted={props.autoplay}
				controls={props.controls}
				onClick={props.handleClick}
			>
				<source
					src={`${props.src}#t=0.1`}
					type='video/mp4'
				/>
				<source
					src={`${props.src}#t=0.1`}
					type='video/webm'
				/>
			</video>

			<Icon name={`${isPlaying ? 'pause' : 'play'}`} />
		</VideoStyle>
	)
})

CustomVideo.displayName = 'CustomVideo'

export default CustomVideo
